import type { Catalog } from "./catalog.js";

// Spanish (Spain). Emergency register, plain language.
// Completed in C7 — full coverage of en.ts (enforced by test/i18n-coverage.test.ts).
export const es: Catalog = {
  "app.name": "Beacon",
  // Onboarding — Promise
  "onboarding.promise.tagline": "Vecinos avisando a vecinos.",
  "onboarding.promise.proof.corroboration": "×14 corroboraciones de mediana por alerta",
  "onboarding.promise.proof.time": "menos de 90 s hasta una alerta corroborada",
  "onboarding.promise.proof.nosignup": "0 cuentas, números de teléfono o registros necesarios",
  "onboarding.promise.continue": "Empezar",
  "onboarding.promise.restore": "Recuperar mi identidad",
  "onboarding.promise.step": "BIENVENIDA",
  // Onboarding — Permissions (JIT-honest)
  "onboarding.perms.step": "PASO 2 / 3",
  "onboarding.perms.title": "Cómo te pide permiso Beacon",
  "onboarding.perms.location": "La ubicación solo sirve para vigilar tu zona. Lo pedimos la primera vez que centras el mapa.",
  "onboarding.perms.notifications": "Las notificaciones llevan las alertas. Lo pedimos la primera vez que las activas.",
  "onboarding.perms.background": "La actualización en segundo plano mantiene las alertas a tiempo. Opcional, se pide en contexto.",
  "onboarding.perms.later": "Configurar más tarde",
  "onboarding.perms.continue": "Continuar",
  // Onboarding — Home
  "onboarding.home.step": "PASO 3 / 3",
  "onboarding.home.title": "¿Dónde está tu zona?",
  "onboarding.home.radius": "Radio de vigilancia",
  "onboarding.home.km": "{n} km",
  "onboarding.home.pickHint": "Mueve el mapa para que el pin marque este lugar.",
  "onboarding.home.confirm": "Vigilar esta zona",
  "onboarding.home.browse": "Por ahora, solo explorar",
  "onboarding.home.locating": "Buscando tu ubicación…",
  "onboarding.home.located": "Marcador en tu ubicación actual — ajústalo si hace falta.",
  "onboarding.home.unavailable": "Ubicación no disponible — mueve el mapa hasta tu casa.",
  // Now tab — status
  "now.meta": "{place} · {radius} km",
  "now.meta.ago": "hace {m} min",
  "now.meta.justNow": "ahora mismo",
  "now.meta.none": "aún sin eventos",
  "now.meta.net": "red {v}",
  "now.meta.netDown": "red —",
  "now.meta.info.title": "Qué significan estos números",
  "now.meta.info.radius": "{radius} km — el radio de vigilancia de tu zona.",
  "now.meta.info.area": "{area} — cuándo llegó el último evento de tu zona (incidente, propagación, tiempo o ayuda).",
  "now.meta.info.net": "red {net} — cuándo se ingirió el último evento en toda la red, de cualquier fuente o vecino en Europa. Si esto avanza y lo tuyo no, la red funciona y simplemente no tiene novedades para ti.",
  "now.meta.info.feeds": "Fuentes detrás de lo que ves: {feeds}.",
  "now.place.default": "tu zona",
  "region.unsupported.title": "Fuera de la región cartografiada",
  "region.unsupported.body": "Aún no hay mapa disponible en esta ubicación.",
  "now.status.step": "AHORA",
  "now.status.allClear": "Todo tranquilo.",
  "now.status.stayAware": "Mantente alerta.",
  "now.status.nearby.fire": "Incendio cerca.",
  "now.status.nearby.flood": "Inundación cerca.",
  "now.status.nearby.earthquake": "Terremoto sentido.",
  "now.status.nearby.conflict": "Peligro cerca.",
  "now.status.nearby.other": "Peligro cerca.",
  "now.status.nearby.traffic": "Corte de tráfico cerca.",
  "now.status.nearby.storm": "Tormenta cerca.",
  "now.status.nearby.snow": "Nieve cerca.",
  "now.status.nearby.ice": "Hielo en las carreteras cerca.",
  "now.status.nearby.heat": "Aviso de calor extremo.",
  "now.status.nearby.fog": "Niebla densa cerca.",
  "now.status.nearby.hazmat": "Alerta de materiales peligrosos cerca.",
  "now.status.nearby.outage": "Corte de suministro cerca.",
  "now.status.sub": "{distance} km · {place}",
  "now.status.sub.allClear": "Nada activo dentro de tu radio de vigilancia.",
  // Now tab — community strip
  "now.community.neighbors": "{n} vecinos",
  "now.community.watching": "VIGILANDO",
  "now.community.helpers": "{n} ayudantes",
  "now.community.helpersLabel": "CERCA",
  "now.community.median": "<90s",
  "now.community.medianLabel": "HASTA ALERTA CORROBORADA",
  "now.community.corroborated": "×{n}",
  "now.community.corroboratedLabel": "CORROBORADO",
  // Now tab — activity + report
  "now.activity.title": "CERCA",
  "now.activity.empty": "Nada cerca ahora mismo.",
  "now.pulse.live": "Red activa — último evento hace {s} s",
  "now.pulse.quiet": "Red en calma desde hace {m} min",
  "now.pulse.unreachable": "No se puede contactar con el relay",
  "now.pulse.area": "Tu zona: último aviso hace {m} min",
  "now.pulse.areaNone": "Tu zona: aún sin avisos",
  "now.zone.addHere": "Estás fuera de tus lugares vigilados — ¿añadir aquí como zona?",
  "now.activity.corroboration": "CORROBORADO ×{n}",
  "now.group.areas": "{n} zonas",
  "now.group.expand": "Mostrar zonas",
  "now.report.button": "Informar",
  "now.recenter": "Recentrar en mí",
  "now.fitAll": "Ver todos los lugares",
  "now.raw.toggle": "Informes brutos",
  "now.raw.list.title": "Informes ({n})",
  "now.raw.list.more": "+{n} más",
  "now.raw.detail": "{hazard} · vía {feed} · {time}",
  "now.report.title": "Informe",
  "now.report.unverified": "Informe sin verificar — aún no corroborado",
  "now.report.event": "Evento",
  "now.report.response": "Respuesta",
  "now.report.severity": "Gravedad",
  "now.report.observed": "Observado",
  "now.report.source": "Fuente",
  "now.warning.viewSource": "Ver aviso completo ↗",
  // Report sheet — corroborate mode
  "report.corroborate.title": "Corroborar",
  "report.corroborate.q": "¿Es este el {hazard} cerca de {place}?",
  "report.corroborate.yes": "Sí, yo también lo veo",
  "report.corroborate.no": "No, esto es distinto",
  // Report sheet — full flow
  "report.title": "Informar de un peligro",
  "report.step.what": "¿Qué ocurre?",
  "report.step.where": "¿Dónde?",
  "report.step.howbad": "¿Cómo de grave?",
  "report.where.here": "Aquí (tu zona)",
  "report.where.honesty": "Se comparte como tu barrio, no tu dirección.",
  "report.where.pick": "Elegir un punto en el mapa",
  "report.where.pickHint": "Arrastra el mapa para que el pin quede en el lugar.",
  "report.where.current": "Ubicación actual",
  "report.where.home": "Casa",
  "report.where.pin": "Marcar en el mapa",
  "report.where.selected": "Informar en",
  "report.where.locating": "Localizando…",
  "report.where.locateFailed": "No se pudo obtener tu ubicación — informando desde casa.",
  "report.note.placeholder": "Añade una línea (opcional)",
  "report.next": "Siguiente",
  "report.back": "Atrás",
  "report.submit": "Enviar informe",
  "report.cancel": "Cancelar",
  "report.severity.label": "Gravedad",
  // Report sheet — confirmation
  "report.done.title": "Enviado",
  "report.done.body": "Visible para los vecinos ahora. Las alertas saltan cuando otros lo corroboran.",
  "report.done.close": "Hecho",
  "report.error": "No se pudo enviar — puedes intentarlo de nuevo.",
  // Hazards (controlled vocab)
  "hazard.fire": "Incendio",
  "hazard.flood": "Inundación",
  "hazard.earthquake": "Terremoto",
  "hazard.conflict": "Peligro",
  "hazard.other": "Peligro",
  "hazard.traffic": "Tráfico", "hazard.storm": "Tormenta", "hazard.snow": "Nieve",
  "hazard.ice": "Hielo", "hazard.heat": "Calor", "hazard.fog": "Niebla",
  "hazard.hazmat": "Materiales peligrosos", "hazard.outage": "Corte de suministro",
  // Chrome
  "tab.now": "Ahora",
  "tab.help": "Ayuda",
  "tab.you": "Tú",
  "tab.talk": "Conversa",
  "tab.beacon": "Ajustes de Beacon",
  "beacon.tab.step": "AJUSTES",
  "beacon.tab.title": "Beacon",
  // Talk tab
  "talk.scope.area": "Mi zona",
  "talk.scope.region": "Región ampliada",
  "talk.region.size": "Tamaño de la región: ~{km} km",
  "talk.band.area": "en tu zona",
  "talk.band.region": "tu región · ~{km} km",
  "talk.band.distant": "lejano",
  "talk.you": "Tú",
  "talk.empty": "Aún no hay mensajes. Saluda a tu zona.",
  "zone.checking": "Comprobando tu zona…",
  "zone.stalled": "Aún sin conexión con la red — seguimos intentando…",
  "zone.progress.windows": "historial {done}/{total}",
  "zone.progress.attempts": "intento {done}/{total}",
  "zone.retry": "Reintentar",
  "talk.placeholder.locked": "🔒 mensaje no disponible",
  "talk.composer.placeholder": "Escribe a tu zona…",
  "talk.composer.send": "Enviar",
  "talk.new.count": "{n} nuevos ↓",
  "talk.zone.home": "Home",
  "talk.zone.nearby": "Nearby",
  "talk.compose.noCell": "Waiting for this place's location…",
  "banner.simulation": "SIMULACIÓN",
  "locale.switch": "Idioma",
  // Alert receipt — toast/takeover (C4)
  "alert.toast.new": "{hazard} informado cerca",
  "alert.toast.escalation": "{hazard} cerca acaba de agravarse",
  "alert.toast.inPath": "{hazard} se acerca hacia ti",
  "alert.toast.reAlert": "{hazard} cerca — actualización",
  "alert.toast.allClear": "Todo tranquilo cerca de {place}",
  "alert.toast.sub": "{distance} km · {place}",
  "alert.toast.tap": "Toca para ver detalles y pasos de seguridad",
  "alert.toast.more": "+{n} más",
  "alert.severity.info": "AVISO",
  "alert.severity.warning": "ALERTA",
  "alert.severity.critical": "CRÍTICO",
  "alert.takeover.title": "{hazard} — actúa ahora",
  "alert.takeover.sub": "{distance} km de {place}",
  "alert.takeover.steps": "PASOS DE SEGURIDAD",
  "alert.takeover.details": "Ver detalles completos",
  "alert.takeover.dismiss": "Descartar",
  "alert.takeover.dismissNext": "Descartar y ver el siguiente · {n} más",
  // IncidentDetail (C4)
  "incident.detail.metrics.corroborated": "×{n}",
  "incident.detail.reports.title": "Informes detrás de esto ({n})",
  "incident.detail.metrics.corroboratedLabel": "CORROBORADO",
  "incident.detail.metrics.first": "{ago}",
  "incident.detail.metrics.firstLabel": "PRIMER INFORME",
  "incident.detail.metrics.spread": "{status}",
  "incident.detail.metrics.spreadLabel": "PROPAGACIÓN",
  "incident.detail.spread.moving": "Avanzando ~{speed} km/h",
  "incident.detail.spread.stationary": "Estable",
  "incident.detail.spread.dissipating": "Remitiendo",
  "incident.detail.spread.unknown": "—",
  "incident.detail.steps": "PASOS DE SEGURIDAD",
  "incident.detail.directions": "Cómo llegar",
  "incident.detail.share": "Compartir",
  "incident.detail.help": "Puedo ayudar",
  "incident.detail.helpSoon": "La coordinación de ayuda llega pronto.",
  "incident.detail.flag": "Informar de un problema con esta alerta",
  "incident.detail.flagSoon": "El marcado llega pronto.",
  "incident.detail.back": "Atrás",
  "incident.detail.away": "{hazard} — a {n} km",
  "incident.detail.ago.min": "hace {n} min",
  "incident.detail.ago.hr": "hace {n} h",
  "incident.detail.ago.now": "ahora mismo",
  // IncidentDetail — details block (origin / how bad / status) + corroborate
  "incident.detail.meta.title": "DETALLES",
  "incident.detail.meta.origin": "Origen",
  "incident.detail.meta.severity": "Gravedad",
  "incident.detail.meta.status": "Estado",
  "incident.detail.origin.crowd": "Comunidad",
  "incident.detail.origin.authority": "Oficial",
  "incident.severity.1": "Leve",
  "incident.severity.2": "Serio",
  "incident.severity.3": "Grave",
  "incident.status.open": "Activo",
  "incident.status.sustained": "En curso",
  "incident.status.closing": "Disminuyendo",
  "incident.status.closed": "Cerrado",
  "incident.detail.seeIt": "Yo también lo veo",
  "incident.detail.seeItDone": "Gracias: tu informe se ha añadido.",
  "incident.detail.tab.safety": "Seguridad",
  "incident.detail.tab.details": "Detalles",
  "incident.detail.tab.actions": "Acciones",
  "incident.detail.helpBrowse": "Ver solicitudes de ayuda",
  // Safety steps — tone-invariant, per hazard (GUI §3)
  "safety.fire.1": "Sal pronto — no esperes a ver las llamas.",
  "safety.fire.2": "Ve a contraviento y cuesta arriba, lejos del humo.",
  "safety.fire.3": "Lleva agua, medicación y el teléfono.",
  "safety.fire.4": "Si quedas atrapado, busca terreno despejado o un edificio.",
  "safety.flood.1": "Sube ya a un lugar más alto.",
  "safety.flood.2": "Nunca camines ni conduzcas por agua en movimiento.",
  "safety.flood.3": "Corta la electricidad si el agua sube dentro de casa.",
  "safety.flood.4": "Aléjate de ríos, desagües y puentes.",
  "safety.earthquake.1": "Agáchate, cúbrete y agárrate hasta que pare el temblor.",
  "safety.earthquake.2": "Aléjate de ventanas y muebles pesados.",
  "safety.earthquake.3": "Tras el temblor, revisa fugas de gas y daños.",
  "safety.earthquake.4": "Cuenta con réplicas — prepárate para cubrirte otra vez.",
  "safety.conflict.1": "Aléjate del peligro y busca refugio.",
  "safety.conflict.2": "Quédate agachado y mantén paredes sólidas entre tú y el peligro.",
  "safety.conflict.3": "Comparte tu situación con alguien de confianza.",
  "safety.conflict.4": "Sigue las indicaciones de emergencia locales.",
  "safety.other.1": "Aléjate del peligro inmediato.",
  "safety.other.2": "Avisa a los vecinos que quizá no lo hayan visto.",
  "safety.other.3": "Sigue las indicaciones de emergencia locales.",
  "safety.traffic.1": "Reduce la velocidad y mantén mayor distancia.",
  "safety.traffic.2": "Sigue las señales y fúndete pronto en el carril.",
  "safety.traffic.3": "Considera una ruta alternativa.",
  "safety.storm.1": "Quédate dentro y aléjate de las ventanas.",
  "safety.storm.2": "Evita viajar hasta que pase.",
  "safety.storm.3": "Asegura los objetos sueltos en el exterior.",
  "safety.storm.4": "Aléjate de árboles y cables eléctricos.",
  "safety.snow.1": "Evita desplazamientos no esenciales.",
  "safety.snow.2": "Abrígate bien y mantén el teléfono cargado.",
  "safety.snow.3": "Despeja las salidas y comprueba el estado de los vecinos.",
  "safety.ice.1": "Ten cuidado en carreteras y caminos.",
  "safety.ice.2": "Reduce la velocidad y frena con suavidad.",
  "safety.ice.3": "Usa calzado con agarre.",
  "safety.heat.1": "Bebe agua con frecuencia.",
  "safety.heat.2": "Permanece a la sombra o en lugares frescos.",
  "safety.heat.3": "Evita el esfuerzo al mediodía.",
  "safety.heat.4": "Comprueba el estado de personas mayores y vulnerables.",
  "safety.fog.1": "Reduce la velocidad y usa luz de cruce.",
  "safety.fog.2": "Mantén mayor distancia.",
  "safety.fog.3": "Evita los adelantamientos.",
  "safety.hazmat.1": "Entra en un local y cierra ventanas y ventilaciones.",
  "safety.hazmat.2": "Evita la zona afectada.",
  "safety.hazmat.3": "Sigue las instrucciones oficiales.",
  "safety.outage.1": "Ahorra batería del teléfono.",
  "safety.outage.2": "Usa linternas, no velas.",
  "safety.outage.3": "Comprueba el estado de vecinos que puedan necesitar ayuda.",
  "offline.strip": "SIN CONEXIÓN · ÚLTIMA SINCRONIZACIÓN {time}",
  // Help tab — need types (controlled vocab)
  "need.medical": "Médica",
  "need.rescue": "Rescate",
  "need.transport": "Transporte",
  "need.shelter": "Refugio",
  "need.supplies": "Suministros",
  "need.hands": "Manos",
  "need.other": "Otro",
  // Help tab — status block (GUI §4)
  "help.status.step": "AYUDA",
  "help.status.some": "{n} personas necesitan ayuda cerca.",
  "help.status.one": "1 persona necesita ayuda cerca.",
  "help.status.none": "No hay solicitudes abiertas cerca.",
  "help.status.sub": "Más cerca: {need} · {distance} km",
  "help.status.subNone": "Aquí verás las peticiones abiertas en tu zona.",
  // Helper mode card
  "help.helper.toggle": "Puedo ayudar",
  "help.helper.intro": "Ofrécete a ayudar a vecinos cerca de ti.",
  "help.helper.tagsLabel": "¿Con qué puedes ayudar?",
  "help.helper.ttlLabel": "¿Durante cuánto tiempo?",
  "help.helper.ttl.today": "Hoy",
  "help.helper.ttl.week": "Esta semana",
  "help.helper.ttl.incident": "Durante este incidente",
  "help.helper.area": "Solo tu zona — ubicación aproximada, nunca tu dirección.",
  "help.helper.register": "Registrar disponibilidad",
  "help.helper.registered": "Estás disponible para ayudar. Te mostraremos peticiones cercanas.",
  "help.helper.tierUnknown": "CONFIANZA · crece según ayudas y te avalan",
  // Requests near you (matcher A7 push, private SSE)
  "help.nearby.title": "Solicitudes cerca de ti",
  "help.nearby.toast": "Alguien cerca necesita {need}",
  "help.nearby.empty": "Aún no hay coincidencias: se te avisará.",
  "help.offer.toast": "Alguien se ofreció a ayudar",
  "help.accept.error": "No se pudo aceptar aún: sincronizando a esa persona. Inténtalo de nuevo en un momento.",
  // Open requests list
  "help.list.title": "PETICIONES ABIERTAS",
  "help.list.empty": "No hay peticiones abiertas en tu zona.",
  "help.list.verified": "◆",
  // Request detail + offer/accept (GUI §4)
  "help.detail.back": "Atrás",
  "help.detail.needLabel": "Necesita {need}",
  "help.detail.urgencyLabel": "URGENCIA",
  "help.detail.location": "Solo zona aproximada",
  "help.detail.honesty": "La dirección exacta solo se comparte si aceptan tu oferta.",
  "help.detail.offer": "Ofrecer ayuda",
  "help.detail.submitOffer": "Enviar oferta",
  "help.detail.notePlaceholder": "Añade una nota (opcional)",
  "help.detail.etaPlaceholder": "Tiempo estimado en minutos (opcional)",
  "help.detail.offersTitle": "OFERTAS",
  "help.detail.offersEmpty": "Aún no hay ofertas. Los vecinos verán esta petición.",
  "help.detail.accept": "Aceptar",
  "help.detail.accepted": "Aceptada",
  "help.detail.acceptCaveat": "Aceptar comparte tu ubicación exacta con esa persona: no se verifica su identidad y no se puede deshacer.",
  "help.detail.offerSent": "Oferta enviada. Te avisaremos si la aceptan.",
  // Create request sheet
  "help.create.button": "Pedir ayuda",
  "help.create.title": "Pedir ayuda",
  "help.create.step.need": "¿Qué necesitas?",
  "help.create.step.what": "¿Qué hace falta?",
  "help.create.step.urgency": "¿Cómo de urgente?",
  "help.create.headlinePlaceholder": "Una línea — ¿qué necesitas?",
  "help.create.peoplePlaceholder": "¿Cuántas personas?",
  "help.create.urgencyLabel": "URGENCIA",
  "help.create.next": "Siguiente",
  "help.create.back": "Atrás",
  "help.create.submit": "Publicar petición",
  "help.create.error": "No se pudo publicar. Inténtalo de nuevo.",
  "help.create.done.title": "Petición publicada.",
  "help.create.done.body": "Los vecinos cercanos pueden verla ahora y ofrecer ayuda.",
  "help.create.done.close": "Hecho",
  // My activity
  "help.activity.title": "TU ACTIVIDAD",
  "help.activity.mine": "Tu petición",
  "help.activity.helping": "Estás ayudando",
  "help.activity.offered": "Ofreciste ayuda",
  "help.activity.pending": "Aún no está en la red",
  "help.screen.resolvedDone": "Resuelto — marcado como hecho.",
  "help.screen.resolvedCancelled": "Esta solicitud se canceló.",
  "help.screen.loading": "Cargando solicitud…",
  "help.activity.activeTitle": "ACTIVAS",
  "help.activity.resolvedTitle": "RESUELTAS",
  "help.activity.badge.done": "Hecho",
  "help.activity.badge.cancelled": "Cancelada",
  "help.activity.badge.active": "Activa",
  // Coordination thread (GUI §4, §6)
  "help.thread.back": "Atrás",
  "help.thread.title": "Coordinación",
  "help.thread.precise": "Ubicación compartida",
  "help.thread.preciseSelf": "Tu ubicación compartida",
  "help.thread.heartbeat": "{name} · {state}",
  "help.thread.composePlaceholder": "Mensaje…",
  "help.thread.send": "Enviar",
  "help.thread.done": "Hecho",
  "help.thread.cantMake": "No puedo ir",
  "help.thread.you": "Tú",
  "help.thread.requester": "Quien pide",
  "help.thread.helper": "Ayudante · {id}",
  "help.thread.resend": "Reenviar",
  "help.thread.empty": "Coordina aquí. Los mensajes están cifrados para todos en esta solicitud.",
  "help.thread.openMap": "Abrir mapa ↗",
  "help.confirm.cancel": "Cancelar",
  "help.confirm.done.title": "¿Marcar como resuelta?",
  "help.confirm.done.body": "Se avisa a quien ayuda y pasa a Resueltas.",
  "help.confirm.done.confirm": "Marcar hecho",
  "help.confirm.cant.title": "¿Retirar tu ayuda?",
  "help.confirm.cant.body": "La solicitud se reabre para otras personas cercanas.",
  "help.confirm.cant.confirm": "Retirar",
  "help.status.chip.open": "Abierta",
  "help.status.chip.accepted": "Aceptada",
  "help.status.chip.enroute": "En camino",
  "help.status.chip.arrived": "Llegó",
  "help.status.chip.partial": "Parcial",
  "help.status.chip.done": "Hecho",
  "help.status.chip.cancelled": "Cancelada",
  // Lifecycle step labels (numbered-steps)
  "help.lifecycle.open": "Abierta",
  "help.lifecycle.offered": "Ofrecida",
  "help.lifecycle.accepted": "Aceptada",
  "help.lifecycle.enroute": "En camino",
  "help.lifecycle.arrived": "Ha llegado",
  "help.lifecycle.done": "Hecho",
  // You tab (GUI §5)
  "you.step": "TÚ",
  "you.title": "Tú y tus ajustes",
  // Location & alerts
  "you.loc.title": "UBICACIÓN Y ALERTAS",
  "you.loc.home": "Zona de residencia",
  "you.loc.setHome": "Definir zona de residencia",
  "you.loc.coords": "Coordenadas",
  "you.loc.change": "Cambiar zona de residencia",
  "you.loc.setHomeHint": "Elige una zona de residencia para ver el mapa y recibir alertas de lo que tienes cerca.",
  "you.loc.radius": "Radio de vigilancia",
  "you.loc.km": "{n} km",
  "you.loc.quiet": "Horas de silencio",
  "you.loc.quietValue": "{start}:00 – {end}:00",
  "you.loc.quietOff": "Desactivado",
  "you.loc.quietToggle": "Silenciar alertas no críticas por la noche",
  "you.loc.autoDismiss": "Descartar avisos tras",
  "you.loc.autoDismiss.seconds": "{n}s",
  "you.loc.autoDismiss.never": "Permanecer hasta descartar",
  "you.loc.minsev": "Gravedad mínima para alertar",
  "you.loc.addPlace": "Añadir otro lugar",
  "you.loc.addCurrent": "Usar la ubicación actual",
  "you.loc.liveFollow": "Seguir mi ubicación",
  "you.loc.liveFollowHint": "Te avisa de peligros donde estás mientras Beacon está abierto. Usa más batería; desactivado por defecto.",
  "you.loc.liveFollowUnavailable": "El acceso a la ubicación está desactivado. Actívalo en tu navegador para seguir tu ubicación.",
  "you.loc.keepAwake": "Mantener la pantalla encendida al seguir",
  "you.loc.keepAwakeHint": "Mantiene la pantalla activa durante el seguimiento en directo para no perder ninguna alerta. Si lo desactivas, un dispositivo en reposo no puede avisarte: una limitación de las aplicaciones web.",
  "you.sound.title": "Sonido de alerta",
  "you.sound.hint": "Reproduce un tono breve con tu voz elegida cuando aparece una alerta. Desactivado hasta que lo enciendas; siempre en silencio durante las horas de silencio.",
  "you.sound.preview": "Reproducir muestra",
  "you.loc.travelRadius": "Radio en ruta",
  "you.loc.places": "LUGARES VIGILADOS",
  "you.loc.placeUnnamed": "Lugar guardado",
  "you.loc.removePlace": "Quitar",
  "now.watched.title": "Otros lugares vigilados",
  "now.watched.alert": "Incendio cerca de {place}",
  "you.loc.editPlace": "Editar",
  "you.loc.placeName": "Nombre",
  "you.loc.homeName": "Nombre de casa",
  "you.loc.moveUp": "Subir",
  "you.loc.moveDown": "Bajar",
  // Voice (supporter-locked)
  "you.voice.title": "TONO",
  "you.voice.intro": "Elige cómo te habla Beacon.",
  "you.voice.official": "Oficial",
  "you.voice.human": "Cercano",
  "you.voice.dark": "Humor negro",
  "you.voice.deadpan": "Impasible",
  "you.voice.nonna": "Abuela",
  "you.voice.preview.official": "Incendio informado 3 km al norte. Corroborado por 14 vecinos.",
  "you.voice.preview.human": "Hay un incendio justo al norte de ti — tus vecinos también lo están viendo.",
  "you.voice.preview.dark": "Fuego al norte. Tan buen momento como cualquiera para estrenar las zapatillas.",
  "you.voice.preview.deadpan": "Fuego al norte. Anotado.",
  "you.voice.preview.nonna": "Hay un fuego justo al norte, cariño — ve ya, te lo digo en serio.",
  // Trust
  "you.trust.title": "CONFIANZA",
  "you.trust.tier": "Tu nivel",
  "you.trust.tierUnknown": "— proporcionado por el proyector (D2)",
  "you.trust.how": "Cómo crece: antigüedad de la cuenta, informes confirmados y avales.",
  "you.trust.factor.age": "Antigüedad de la cuenta",
  "you.trust.factor.confirmed": "Informes confirmados",
  "you.trust.factor.vouches": "Avales",
  "you.trust.factorValue": "— proporcionado por el proyector (D2)",
  "you.trust.vouch": "Avalar a un vecino",
  "you.trust.vouchHint": "Comparte este enlace en persona con alguien de confianza.",
  "you.trust.vouchers": "Tus avalistas",
  "you.trust.vouchersEmpty": "— proporcionado por el proyector (D2)",
  "you.trust.backup": "Copia de seguridad y rotación de claves",
  "you.trust.export": "Descargar mi archivo de recuperación",
  "you.trust.exportHint": "Este archivo es tu cuenta. Guárdalo en un lugar seguro y privado.",
  "you.trust.import": "Restaurar desde un archivo de recuperación",
  "you.trust.rotate": "Rotar mis claves",
  "you.trust.rotateHint": "Sustituye tus claves de firma. Descarga un archivo de recuperación nuevo después.",
  "you.trust.rotated": "Claves rotadas. Descarga ahora tu nuevo archivo de recuperación.",
  "you.trust.importBad": "Ese archivo no es un archivo de recuperación de Beacon válido.",
  "you.trust.importOk": "Archivo de recuperación aceptado. Se usará en el próximo inicio.",
  "you.trust.capability.direct": "Tus informes alertan a tu área directamente.",
  "you.trust.capability.needsConfirm": "Ahora mismo un vecino necesita confirmar tu informe antes de alertar al área.",
  "you.trust.capability.full": "Tus informes ya tienen pleno peso. Las alertas grandes aún necesitan que algunos vecinos las confirmen — así es como Beacon se mantiene fiable.",
  "you.trust.progress.confirmed": "Tras {confirmed} informe(s) confirmado(s) más, tus informes tendrán más peso.",
  "you.trust.progress.days": "Sigue usando Beacon durante unos {days} día(s) más para ganar reputación.",
  // Privacy
  "you.privacy.title": "PRIVACIDAD",
  "you.privacy.consentTitle": "A qué has dado tu consentimiento",
  "you.consent.alerts": "Recibir alertas de mi zona",
  "you.consent.helperAvailability": "Compartir mi disponibilidad para ayudar",
  "you.consent.preciseLocationRelease": "Divulgar mi ubicación exacta cuando acepto una petición",
  "you.consent.publicMetrics": "Contribuir a métricas públicas anónimas",
  "you.privacy.export": "Exportar mis datos",
  "you.privacy.exportHint": "Una copia portátil de todo lo que hay en este dispositivo.",
  "you.privacy.erase": "Borrarme",
  "you.privacy.eraseHint": "Cripto-borrado: tus claves se destruyen y tus datos quedan inaccesibles en todas partes.",
  // Seguridad y privacidad — qué protege el chat de ayuda y sus límites.
  "you.safety.title": "SEGURIDAD Y PRIVACIDAD",
  "you.safety.intro": "Qué se protege cuando pides o ofreces ayuda, y dónde están los límites.",
  "you.safety.toggle": "Cómo se protege tu seguridad",
  "you.safety.e2ee.h": "Los mensajes están cifrados de extremo a extremo",
  "you.safety.e2ee.d": "Solo tú y la persona con quien te coordinas podéis leerlos: ni Beacon ni el relé.",
  "you.safety.location.h": "Tu ubicación exacta queda privada hasta que aceptas",
  "you.safety.location.d": "Quien ayuda solo ve tu zona aproximada. En cuanto aceptas a alguien, solo esa persona recibe tu ubicación precisa.",
  "you.safety.metadata.h": "La red puede ver que te estás coordinando",
  "you.safety.metadata.d": "Tus palabras y tu ubicación exacta están ocultas, pero sí se ve que estás recibiendo ayuda, tu zona aproximada y el momento. Trata tu barrio como público.",
  "you.safety.identity.h": "No se verifica la identidad de quien ayuda",
  "you.safety.identity.d": "Cualquiera puede ofrecer ayuda con cualquier nombre. Comparte datos sensibles solo cuando tengas claro con quién tratas.",
  "you.safety.irrevocable.h": "Compartir tu ubicación precisa no se puede deshacer",
  "you.safety.irrevocable.d": "Una vez que aceptas, esa persona conserva la ubicación que compartiste. No hay vuelta atrás.",
  "you.safety.forwardSecrecy.h": "Los mensajes antiguos dependen de la seguridad de tu dispositivo",
  "you.safety.forwardSecrecy.d": "Beacon aún no usa una clave nueva para cada mensaje, así que una clave robada podría exponer chats pasados. Mantén tu teléfono bloqueado.",
  "you.safety.retention.h": "Los mensajes caducan, pero no puedes borrarlos",
  "you.safety.retention.d": "Los mensajes de coordinación desaparecen solos al cabo de un tiempo. Todavía no hay borrado manual mensaje a mensaje.",
  // Erase confirmation (grave)
  "you.erase.title": "¿Borrarte de Beacon?",
  "you.erase.body": "Esto destruye las claves que desbloquean todo lo que has compartido. Los informes y mensajes que ya están en los teléfonos de los vecinos no se pueden recuperar, pero todo lo demás queda permanentemente inaccesible. Esto no se puede deshacer.",
  "you.erase.confirmLabel": "Escribe BORRAR para confirmar",
  "you.erase.confirmWord": "BORRAR",
  "you.erase.cancel": "Mantener mi cuenta",
  "you.erase.confirm": "Borrarme",
  "you.erase.done": "Tu solicitud de borrado está firmada y en camino. Adiós.",
  // Support Beacon
  // App
  "you.app.title": "APLICACIÓN",
  "you.app.language": "Idioma",
  "you.app.notifications": "Notificaciones",
  "you.app.notificationsOn": "Activadas",
  "you.app.notificationsOff": "Desactivadas",
  "you.notif.enabled": "Notificaciones activadas. Te avisaremos aunque Beacon esté cerrado.",
  "you.notif.denied": "Las notificaciones están bloqueadas. Permítelas en los ajustes del navegador para recibir avisos con Beacon cerrado.",
  "you.notif.unsupported": "Este navegador no puede mostrar notificaciones con Beacon cerrado. Las alertas dentro de la app siguen funcionando.",
  "you.notif.nopush": "Notificaciones permitidas, pero el envío aún no está configurado en este servidor. Las alertas dentro de la app siguen funcionando.",
  "you.notif.subfail": "Notificaciones permitidas, pero este dispositivo no pudo activar el envío. Las alertas dentro de la app siguen funcionando.",
  "you.notif.subfail.noservice": "Notificaciones permitidas, pero este dispositivo no tiene servicio de envío (p. ej. sin Google Play). Las alertas dentro de la app funcionan; para las de segundo plano usa Chrome o la próxima app de Beacon.",
  "you.notif.dismissed": "Sin avisos con Beacon cerrado hasta que permitas las notificaciones. Actívalas cuando quieras.",
  "you.app.about": "Acerca de Beacon",
  "you.app.version": "Versión piloto",
  // Flags & appeals (only if non-empty)
  "you.flags.title": "TUS MARCADOS Y RECURSOS",
  // E2 moderation — flag sheet
  "flag.title": "Informar de un problema",
  "flag.intro": "Las denuncias son privadas. El autor nunca sabe quién denunció.",
  "flag.reason.falseReport": "Falso o engañoso",
  "flag.reason.spam": "Spam",
  "flag.reason.harassment": "Acoso",
  "flag.reason.dangerousAdvice": "Consejo peligroso",
  "flag.reason.harvestAttempt": "Intento de recopilar ubicaciones",
  "flag.reason.doxxing": "Divulgación de datos personales",
  "flag.reason.illegal": "Contenido ilegal",
  "flag.reason.other": "Otra cosa",
  "flag.submit": "Enviar denuncia",
  "flag.done": "Gracias — los moderadores lo revisarán.",
  "flag.error": "No se pudo enviar. Inténtalo de nuevo.",
  // E2 moderation — You transparency surface
  "you.flags.empty": "Nada aquí. Sin acciones sobre tus informes.",
  "you.flags.actionLabel": "Acción sobre tu actividad",
  "you.flags.weight": "Se muestra más abajo en el orden",
  "you.flags.reversible": "Esto es reversible y temporal. Puedes apelar.",
  "you.flags.appeal": "Apelar",
  "you.flags.expires": "Caduca {date}",
  // E2 moderation — appeal sheet
  "appeal.title": "Apelación",
  "appeal.intro": "Explica por qué debe revertirse. Un moderador lo revisa.",
  "appeal.statement.placeholder": "¿Por qué es incorrecto?",
  "appeal.submit": "Enviar apelación",
  "appeal.done": "Apelación enviada. Verás el resultado aquí.",
  "appeal.error": "No se pudo enviar la apelación. Inténtalo de nuevo.",
  // E9 incident detail — trend / freshness / source / advanced (Task 3)
  "incident.detail.meta.lastConfirmed": "Última confirmación",
  "incident.detail.meta.wind": "Viento",
  "incident.detail.meta.trend": "Tendencia",
  "incident.detail.meta.sources": "Fuentes",
  "incident.detail.trend.rising": "Intensificándose",
  "incident.detail.trend.steady": "Estable",
  "incident.detail.trend.falling": "Remitiendo",
  "incident.detail.worsening": "Empeorando",
  "incident.detail.adv.title": "Avanzado",
  "incident.detail.adv.intensity": "Potencia radiativa",
  "incident.detail.adv.mw": "{n} MW",
  "incident.detail.adv.peak": "(pico {n} MW)",
  "incident.detail.adv.trendAxes": "Detalle de tendencia",
  "incident.detail.adv.weight": "Peso de corroboración",
  "incident.detail.adv.identities": "Autoridades confirmadoras",
  "incident.detail.adv.axis.rising": "↑",
  "incident.detail.adv.axis.steady": "→",
  "incident.detail.adv.axis.falling": "↓",
  "incident.detail.wind": "{speed} km/h desde {dir}",
  "compass.n": "N",
  "compass.ne": "NE",
  "compass.e": "E",
  "compass.se": "SE",
  "compass.s": "S",
  "compass.sw": "SO",
  "compass.w": "O",
  "compass.nw": "NO",
  "incident.source.nasa-firms": "NASA FIRMS",
  "incident.source.fogos.pt": "fogos.pt",
  "incident.source.anepc": "ANEPC",
  "now.activity.confirmedAgo": "confirmado {ago}",
  "now.activity.worsening": "▲ intensificándose",
  // Install pointer (M3)
  "you.get.title": "INSTALA BEACON EN EL MÓVIL",
  "you.get.body": "Instala Beacon para recibir alertas aunque esté cerrado.",
  "you.get.cta": "Obtener Beacon",
  "install.title": "Instala Beacon en el móvil",
  "install.desktop.intro": "Beacon te avisa de peligros cercanos aunque la página esté cerrada.",
  "install.desktop.scan": "Escanea para abrir Beacon en el móvil.",
  "install.ios.intro": "Instala Beacon para recibir alertas aunque esté cerrado.",
  "install.ios.step.share": "Toca el botón Compartir.",
  "install.ios.step.add": "Elige «Añadir a pantalla de inicio».",
  "install.ios.step.open": "Abre Beacon desde la pantalla de inicio.",
  "install.ios.note": "Sin tienda de aplicaciones, nada que descargar.",
  "install.android.intro": "Instala Beacon para recibir alertas aunque esté cerrado.",
  "install.android.install": "Instalar Beacon",
  "install.android.apk": "APK autoalojado (sin Google)",
  "install.hint.title": "Instalar Beacon",
  "install.hint.body": "Recibe alertas aunque Beacon esté cerrado.",
  "install.hint.cta": "Instalar",
  "install.hint.dismiss": "Descartar",
  // You-tab cleanup (field card + disclosures)
  "you.card.trusted": "Vecino de confianza",
  "you.card.building": "Ganando confianza",
  "you.card.neighbor": "Vecino",
  "you.card.watch": "vigilancia de {n} km",
  "you.card.noHome": "Sin zona de casa definida",
  "you.loc.alertDetail": "Ajustar alertas",
  "you.loc.livePosition": "Posición en directo",
  "you.loc.level.off": "Desactivado",
  "you.loc.level.info": "Info",
  "you.loc.level.warning": "Aviso",
  "you.loc.level.critical": "Crítico",
  "you.trust.howToggle": "Cómo funciona la confianza",
  "you.trust.keysToggle": "Claves y recuperación",
  "you.privacy.dataToggle": "Tus datos",
  "you.card.id": "ID de Beacon",
  "you.loc.homeTitle": "CASA Y LUGARES",
  "you.loc.alertsTitle": "ALERTAS",
  "you.loc.removeConfirm": "¿Quitar?",
  "you.loc.cancel": "Cancelar",
  // Advanced — raw-report layer (power-user opt-in)
  "you.raw.title": "Informes brutos (avanzado)",
  "you.raw.toggle": "Mostrar informes individuales en el mapa",
  "you.raw.warning": "Los informes brutos tienen mucho más volumen que los incidentes confirmados y consumen más datos y batería. ¿Activar de todos modos?",
  "you.raw.depth.label": "Hasta qué punto cargar",
  "you.raw.depth.off": "Solo en directo",
  "you.raw.depth.shallow": "Superficial",
  "you.raw.depth.medium": "Medio",
  "you.raw.depth.deep": "Profundo",
  // Advanced — spread-cone debug cells (authoritative H3 overlay)
  "you.cone.title": "Celdas del cono (avanzado)",
  "you.cone.toggle": "Mostrar las celdas exactas del motor de alertas",
  "you.cone.helper": "Superpone las celdas H3 autoritativas que el motor de alertas usa para decidir quién está en la trayectoria de un peligro: útil para comprobar por qué llegó o no una alerta.",

  "commons.card.title": "El común",
  "commons.card.thisPeriod": "Este periodo",
  "commons.card.runRate": "Coste recurrente frente a aportaciones",
  "commons.card.cumulative": "Histórico",
  "commons.card.oneTime": "Puntual (p. ej. desarrollo)",
  "commons.card.yourCost": "Tu parte justa hasta ahora",
  "commons.card.yourGiven": "Has aportado",
  "commons.card.operatorStated": "declarado por el operador",
  "commons.card.chipIn": "Aportar",
  "commons.card.chippedIn": "Ya has aportado este mes — gracias.",
  "commons.card.need": "Beacon necesitó {amount} este mes para avisarte.",
  "commons.card.viewTransparency": "Ver transparencia",
  "commons.card.deficit": "Déficit",
  "commons.card.surplus": "Superávit",
  "commons.card.empty": "Aún no hay actividad del común.",
  "commons.chipIn.title": "Aporta al común",
  "commons.chipIn.pickToken": "Elige qué enviar",
  "commons.chipIn.amount": "Importe (opcional)",
  "commons.chipIn.getAddress": "Obtener dirección",
  "commons.chipIn.address": "Envía a esta dirección",
  "commons.chipIn.copy": "Copiar dirección",
  "commons.chipIn.copied": "Copiada",
  "commons.chipIn.deadline": "Paga en {min} min para que se te acredite. Los pagos tardíos también ayudan al común, pero no se mostrarán en tu tarjeta.",
  "commons.chipIn.oneClick": "Pagar con la cartera conectada",
  "commons.chipIn.noWallet": "No se detectó ninguna cartera en el navegador: escanea o pega la dirección.",
  "commons.chipIn.sent": "Transacción enviada",
  "commons.chipIn.error": "No se pudo obtener una dirección. Inténtalo de nuevo.",
  "commons.chipIn.intro": "Una aportación puntual para los costes de funcionamiento de esta instancia — en cadena, sin registro.",
  "commons.chipIn.network": "Envía en {network}",
  "commons.chipIn.wrongChain": "Envía solo en esta red: los fondos en otra cadena no se pueden detectar.",
  "commons.chipIn.afterTitle": "Después de enviar",
  "commons.chipIn.afterDetect": "Tu depósito se detecta automáticamente en la cadena: no tienes que hacer nada más.",
  "commons.chipIn.afterAppear": "Cuando la red lo confirme (normalmente uno o dos minutos), aparecerá en el común y en tu tarjeta si pagaste dentro del plazo.",
  "commons.chipIn.done": "Hecho",
  "commons.chipIn.close": "Cerrar",
  "commons.received": "Aportación recibida. ¡Gracias!",
  "commons.chipIn.waiting": "Esperando tu depósito en la cadena…",
  "commons.chipIn.receivedTitle": "Aportación recibida",
  "commons.chipIn.receivedBody": "Gracias por aportar: ya está en el libro del común.",
  "commons.privacy.hidden": "Oculto para todos",
  "commons.privacy.public": "Oculto en público, visto brevemente por esta instancia",
  "commons.privacy.custodial": "Tu banco/proveedor ve esto",
  "commons.transparency.title": "Transparencia del común",
  "commons.transparency.intro": "Calculado por completo a partir de eventos firmados en el firehose. Cualquiera puede reproducirlo de forma independiente.",
  "commons.transparency.series": "Coste recurrente frente a aportaciones, por periodo",
  "commons.transparency.oneTimeSeries": "Costes puntuales, por periodo",
  "commons.transparency.projection": "Este periodo (estimación, prorrateo)",
  "commons.transparency.history": "Historial hasta el génesis",
  "commons.transparency.basis": "Base del denominador",
  "commons.transparency.reproduce": "Reprodúcelo desde el firehose: cada dato es un evento firmado de coste o aportación.",
  "commons.transparency.colCost": "Coste recurrente",
  "commons.transparency.colContrib": "Aportaciones",
  "commons.transparency.colNet": "Neto",
  "commons.transparency.colOneTime": "Puntual",
  "commons.transparency.estimate": "estimación",
};
